import type { MaybeRef } from 'vue'
import type { PagingSortingFilteringDetails } from '@/types/paging/paging-sorting-filtering-details.model'
import { unref } from 'vue'

export const LOCATION_FUEL_COST_KEYS = {
  root: ['location-fuel-costs'] as const,
  byCountryCode: (countryCode: MaybeRef<number>) => [...LOCATION_FUEL_COST_KEYS.root, unref(countryCode)],
  byId: (id: MaybeRef<string>) => [...LOCATION_FUEL_COST_KEYS.root, unref(id)] as const,
}

export const TICKET_KEYS = {
  root: ['tickets'] as const,
  byId: (id: MaybeRef<string>) => [...TICKET_KEYS.root, unref(id)] as const,
  byIdWithReplies: (id: MaybeRef<string>) => [...TICKET_KEYS.byId(id), 'replies'] as const,
}

export const USER_KEYS = {
  root: ['users'] as const,
  byId: (id: MaybeRef<string>) => [...USER_KEYS.root, unref(id)] as const,
  current: () => [...USER_KEYS.root, 'current'],
  org: () => [...USER_KEYS.root, 'org'] as const,
  orgWithParams: (params: MaybeRef<PagingSortingFilteringDetails>) => [...USER_KEYS.org(), unref(params)] as const,
  partner: () => [...USER_KEYS.root, 'partner'] as const,
  partnerWithParams: (params: MaybeRef<PagingSortingFilteringDetails>) => [...USER_KEYS.partner(), unref(params)] as const,
  sites: () => [...USER_KEYS.current(), 'sites'] as const,
  sysAdmin: () => [...USER_KEYS.root, 'sys-admin'] as const,
  sysAdminWithParams: (params: MaybeRef<PagingSortingFilteringDetails>) => [...USER_KEYS.sysAdmin(), unref(params)] as const,
}

export const PUSH_SUBSCRIPTION_KEYS = {
  root: ['push-subscriptions'] as const,
  list: () => [...PUSH_SUBSCRIPTION_KEYS.root] as const,
  shouldPrompt: () => [...PUSH_SUBSCRIPTION_KEYS.root, 'should-prompt'] as const,
}
